import { useBetslipData } from './use-betslip-data';
import { useBetslipStore } from './use-betslip-store';

/**
 * Custom hook to determine if the mystery mode is applied and the potential max winnings for mystery.
 */
export const useMysteryMode = () => {
    const { mysteryMultipliers } = useBetslipData();
    const selectedPromo = useBetslipStore(state => state.selectedPromo);
    const entryAmount = useBetslipStore(state => state.entryAmount ?? 0);
    const mysteryApplied = selectedPromo?.promotion.type === 'MYSTERY';

    const mysteryToWin = mysteryMultipliers ? entryAmount * mysteryMultipliers.max : undefined;

    return {
        mysteryApplied,
        mysteryToWin,
    };
};
